import axios from 'axios'
import router from '@/router'
import store from '@/store'
import common from '@/mixins/common'
const { toastError } = common.methods

let isHandling401 = false;
let isHandling500 = false;

// 백엔드 API 기본 주소
const api = axios.create({
  baseURL: '/api',
})

api.interceptors.request.use(config => {
  const token = localStorage.getItem('jwtToken')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
    
    const route = router.currentRoute.value
    const page = route?.name || route?.path || 'UNKNOWN_PAGE'
    const action = (config.method || 'GET').toUpperCase()
    config.headers['X-Log-Screen'] = `${page}`
    config.headers['X-Log-Method'] = `${action}`
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    if (error.response && error.response.status === 401) {
      if (!isHandling401) {
        isHandling401 = true
        store.commit('UserStore/clearAuth')
        localStorage.removeItem('jwtToken')
        localStorage.removeItem('userInfo')

        router.push('/sign-in')

        toastError('세션이 만료되었습니다. 다시 로그인해주세요.');
        router.push('/sign-in').finally(() => {
          setTimeout(() => { isHandling401 = false }, 500)
        })
      }
    } else if (status === 502) {
        toastError('502에러 발생.');
    } else if (status === 413) {
        toastError('업로드 용량이 제한되었습니다.');
    } else if (status >= 500) {
      if (!isHandling500) {
        isHandling500 = true;

        const reqId =
          error.response.headers['x-request-id'] ||
          error.response.headers['x-correlation-id'] ||
          '';
        const cur = router.currentRoute.value;
        if (cur?.name !== 'Error500') {
          router.replace({ name: 'Error500', query: { reqId } }).catch(() => {});
        }

        setTimeout(() => { isHandling500 = false; }, 500);
      }
    }

    return Promise.reject(error)
  }
)

export default api